const initialState = {
  blog: {
    posts: [],
    loading: false,
    error: null
  },
  projects: {
    projects: [],
    loading: false,
    error: null
  }
}

export default initialState;